import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMenuProductDetail } from "src/models/POS/MenuProduct.models";

interface MenuProductDetailState {
  menuProductDetails: IMenuProductDetail[];
  menuProductDetailToEdit: IMenuProductDetail | null;
}

const initialState: MenuProductDetailState = {
  menuProductDetails: [],
  menuProductDetailToEdit: null,
};

const menuProductDetailSlice = createSlice({
  name: "MenuProductDetail",
  initialState,
  reducers: {
    setMenuProductDetailList: (
      state,
      action: PayloadAction<IMenuProductDetail[]>
    ) => {
      state.menuProductDetails = action.payload;
    },
    setMenuProductDetailToEdit: (
      state,
      action: PayloadAction<IMenuProductDetail | null>
    ) => {
      state.menuProductDetailToEdit = action.payload;
    },
    concatListMenuProductDetail: (
      state: MenuProductDetailState,
      action: PayloadAction<IMenuProductDetail[]>
    ) => {
      state.menuProductDetails = [
        ...state.menuProductDetails.concat(action.payload),
      ];
    },
    addMenuProductDetail: (
      state,
      action: PayloadAction<IMenuProductDetail>
    ) => {
      state.menuProductDetails.push(action.payload);
    },
    updateMenuProductDetail: (
      state,
      action: PayloadAction<IMenuProductDetail>
    ) => {
      let itemIndex = state.menuProductDetails.findIndex(
        item => item.menuProductDetailId === action.payload.menuProductDetailId
      );
      if (itemIndex !== -1)
        state.menuProductDetails[itemIndex] = action.payload;
    },
    deleteMenuProductDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.menuProductDetails.filter(
        item => item.menuProductDetailId !== action.payload
      );
      state.menuProductDetails = newArray;
    },
  },
});

export const {
  setMenuProductDetailList,
  concatListMenuProductDetail,
  setMenuProductDetailToEdit,
  addMenuProductDetail,
  updateMenuProductDetail,
  deleteMenuProductDetail,
} = menuProductDetailSlice.actions;

export default menuProductDetailSlice.reducer;
